import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageSpinner } from 'src/components/spinner-container';
import { CompanyInformationOverview } from 'src/pages/settings/organisation/company-information';
import { EditGeneralInformation } from 'src/pages/settings/organisation/company-information/edit-general-information';
import {
  EditSsoInformation,
  EditTsoInformation,
} from 'src/pages/settings/organisation/company-information/edit-operator-information';
import { EditShipperInformation } from 'src/pages/settings/organisation/company-information/edit-shipper-information';
import { ShipperRoleWizard } from 'src/pages/settings/organisation/company-information/shipper-role-wizard';
import { ContactsOverview } from 'src/pages/settings/organisation/contacts';
import { CreateContact } from 'src/pages/settings/organisation/contacts/create';
import { EditContact } from 'src/pages/settings/organisation/contacts/edit';
import { useOrganisationService } from 'src/pages/settings/organisation/use-organisation-service';
import { UsersOverview } from 'src/pages/settings/organisation/users';
import { UserDetails } from 'src/pages/settings/organisation/users/details';
import { EditUser } from 'src/pages/settings/organisation/users/details/edit';
import { UpgradeToAdmin } from 'src/pages/settings/organisation/users/details/upgrade-to-admin';
import { InviteUser } from 'src/pages/settings/organisation/users/invite';
import { InviteUserSuccess } from 'src/pages/settings/organisation/users/invite/success';

export const OrganisationManagement: FC = () => {
  const organisationService = useOrganisationService();

  if (!organisationService.response) return <PageSpinner />;

  return (
    <Switch>
      <Route path="/settings/organisation/users" exact>
        <UsersOverview organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/users/invite" exact>
        <InviteUser organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/users/invite/success" exact>
        <InviteUserSuccess />
      </Route>

      <Route path="/settings/organisation/users/:userId" exact>
        <UserDetails organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/users/:userId/edit" exact>
        <EditUser organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/users/:userId/upgrade-to-admin" exact>
        <UpgradeToAdmin organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/contacts" exact>
        <ContactsOverview organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/contacts/create" exact>
        <CreateContact organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/contacts/:contactId/edit" exact>
        <EditContact organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/company-information" exact>
        <CompanyInformationOverview organisationService={organisationService} />
      </Route>

      <Route path="/settings/organisation/company-information/edit" exact>
        <EditGeneralInformation organisationService={organisationService} />
      </Route>

      <Route
        path="/settings/organisation/company-information/edit-shipper-details"
        exact
      >
        <EditShipperInformation organisationService={organisationService} />
      </Route>

      <Route
        path="/settings/organisation/company-information/edit-sso-details"
        exact
      >
        <EditSsoInformation
          title="Edit SSO Related Information"
          organisationService={organisationService}
        />
      </Route>

      <Route
        path="/settings/organisation/company-information/edit-tso-details"
        exact
      >
        <EditTsoInformation
          title="Edit TSO Related Information"
          organisationService={organisationService}
        />
      </Route>

      <Route path="/settings/organisation/company-information/apply-for-shipper-role">
        <ShipperRoleWizard organisationService={organisationService} />
      </Route>

      <Route>
        <ThrowNotFound />
      </Route>
    </Switch>
  );
};
